import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// Element defaults to Chinese (pagination "N items total", empty table text, etc.); this app is an English UI, so switch it to English
import ElementLocale from 'element-ui/lib/locale/lang/en';
// The theme must be imported after Element: it overrides its default radii/borders/table styles to unify the look
import './assets/theme.css';

Vue.config.productionTip = false

Vue.use(ElementUI, { locale: ElementLocale });

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
